module.exports = __webpack_public_path__ + "img/J12002.df9eec8c.png";